module.exports = __webpack_public_path__ + "static/img/c7.9cd83619.png";